var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-overlay",class:{ show: !_vm.loading.loadingIgnore && _vm.loading.isLoading }},[_c('Loader',{staticClass:"loading",attrs:{"loading":_vm.loading.isLoading,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }